/* eslint-disable react-hooks/exhaustive-deps */
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { Page, Text, View, Document, StyleSheet, pdf, Font, Image } from "@react-pdf/renderer";
import dayjs from 'dayjs';
import { formatPrice } from '../../utils';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../assets/fonts/rudawregular2.ttf';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import WalletTransferService from '../../services/walletTransferService';
import { useCompany } from '../../provider/companyProvider';
import { fileApiRoute } from "../../services/networkService";

const registerFont = () => {
    Font.register({
        family: 'Rudaw',
        fonts: [{ src: Rudaw, fontWeight: 'normal' }],
    });
};

const PdfWalletTransfer = ({ data }) => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language !== 'en';
    const [transfers, setTransfers] = useState([]);
    const [totalDeposit, setTotalDeposit] = useState(0);
    const [totalWithdraw, setTotalWithdraw] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const { business } = useCompany();

    const styles = StyleSheet.create({
        page: {
            padding: 30,
            direction: isRTL ? 'rtl' : 'ltr',
            fontFamily: 'Rudaw',
        },
        title: {
            fontSize: 18,
            textAlign: "center",
            fontWeight: "bold",
            marginTop: 10
        },
        infoSection: {
            marginBottom: 20,
            padding: 10,
            border: "1px solid #ccc",
            borderRadius: 5,
            fontSize: 14,
        },
        row: {
            flexDirection: isRTL ? 'row-reverse' : 'row',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        key: {
            fontWeight: 'bold',
            width: '40%',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
        },
        value: {
            flex: 1,
            textAlign: isRTL ? 'right' : 'left',
            paddingLeft: 1,
        },
        table: {
            display: "table",
            width: "auto",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#ccc",
            marginBottom: 20,
        },
        tableRow: {
            flexDirection: isRTL ? "row-reverse" : "row",
        },
        tableCell: {
            // flex: 1,
            padding: 5,
            borderRightWidth: 1,
            borderBottomWidth: 1,
            borderColor: "#ccc",
            textAlign: "center",
            fontSize: 10,
        },
        // total: {
        //     textAlign: isRTL ? "left" : "right",
        //     fontSize: 12,
        //     fontWeight: "bold",
        // },
        footer: {
            display: 'flex',
            flexDirection: isRTL ? 'row-reverse' : 'row',
            justifyContent: 'space-between',
            paddingVertical: 3,
            alignItems: 'center',
            direction: isRTL ? 'rtl' : 'ltr',
            textAlign: isRTL ? 'right' : 'left',
            fontSize: 12
        },
    });

    const MyDocument = () => {
        const { user, branch, type, time } = data;

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    {/* Title */}
                    <View style={{ flexDirection: "row", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>
                        <Image src={`${fileApiRoute}/${business.logo}`} style={{ width: 100, height: 50 }} />
                        <View style={{ width: 10 }}></View>
                        <Text style={styles.title}>{t('walletTransferReport')}</Text>
                    </View>

                    {/* Information Section */}
                    <View style={styles.infoSection}>
                        {branch && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('branch')}:</Text>
                                <Text style={styles.value}>{branch.name}</Text>
                            </View>
                        )}
                        {user && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('user')}:</Text>
                                <Text style={styles.value}>{user.name}</Text>
                            </View>
                        )}
                        {type && (
                            <View style={styles.row}>
                                <Text style={styles.key}>{t('type')}:</Text>
                                <Text style={styles.value}>{t(type)}</Text>
                            </View>
                        )}
                        {time && (
                            time.time !== '' ?
                                (
                                    <View style={styles.row}>
                                        <Text style={styles.key}>{t('duration')}:</Text>
                                        <Text style={styles.value}>{t(time.time)}</Text>
                                    </View>
                                ) : (
                                    <>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('startDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.from).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                        <View style={styles.row}>
                                            <Text style={styles.key}>{t('endDate')}:</Text>
                                            <Text style={styles.value}>
                                                {dayjs(time.to).format('DD/MM/YYYY')}
                                            </Text>
                                        </View>
                                    </>
                                )
                        )}
                        <View style={styles.row}>
                            <Text style={styles.key}>{t('currentDate')}:</Text>
                            <Text style={styles.value}>
                                {dayjs(new Date()).format('DD/MM/YYYY')}
                            </Text>
                        </View>
                    </View>



                    {/* Table */}
                    <View style={styles.table}>
                        {/* Table Header */}
                        <View style={[styles.tableRow, { backgroundColor: "#f0f0f0" }]}>
                            <Text style={[styles.tableCell, { width: '16%' }]}>{t('user')}</Text>
                            <Text style={[styles.tableCell, { width: '16%' }]}>{t('type')}</Text>
                            <Text style={[styles.tableCell, { width: '13%' }]}>{t('amount')}</Text>
                            <Text style={[styles.tableCell, { width: '23%' }]}>{t('date')}</Text>
                            <Text style={[styles.tableCell, { width: '32%' }]}>{t('note')}</Text>
                        </View>

                        {/* Table Rows */}
                        {transfers?.map((transfer, index) => (
                            <View key={index} style={styles.tableRow}>
                                <Text style={[styles.tableCell, { width: '16%' }]}>{transfer.user.name}</Text>
                                <Text style={[styles.tableCell, { width: '16%' }]}>{t(transfer.type)}</Text>
                                <Text style={[styles.tableCell, { width: '13%' }]}>{formatPrice(transfer.amount)}</Text>
                                <Text style={[styles.tableCell, { width: '23%' }]}>{transfer.date}</Text>
                                <Text style={[styles.tableCell, { width: '32%' }]}>{transfer.note}</Text>
                            </View>
                        ))}
                    </View>

                    <View style={styles.footer}>
                        <Text style={styles.total}>{t('totalDeposit')}: {formatPrice(totalDeposit)}</Text>
                        <Text style={styles.total}>{t('totalWithdraw')}: {formatPrice(totalWithdraw)}</Text>
                    </View>
                </Page>
            </Document>
        );
    };


    const fetchTransfers = async () => {
        try {
            setIsLoading(true);
            const filters = data && {
                userId: data.user && data.user.id,
                type: data.type,
                branchId: data.branch && data.branch.id,
                name: data.name,
                deleted: data.deleted,
                ...data.time,
                sortBy: 'date',
                order: 'asc'
            };

            const responseData = await WalletTransferService.fetchAll(filters);

            setTransfers(responseData.transaction);
            setTotalDeposit(responseData.totalDeposit);
            setTotalWithdraw(responseData.totalWithdraw);
        } catch (error) {
            console.error("Failed to fetch transfers:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePrint = async () => {
        registerFont();
        await fetchTransfers();
    };

    useEffect(() => {
        if (transfers.length > 0) {
            (async () => {
                try {
                    const blob = await pdf(<MyDocument />).toBlob();
                    if (blob) {
                        const url = URL.createObjectURL(blob);
                        window.open(url);
                    } else {
                        console.error("Failed to generate PDF blob.");
                    }
                } catch (error) {
                    console.error("Error generating PDF:", error);
                }
            })();
        }
    }, [transfers]);

    return (
        // <PDFDownloadLink document={<MyDocument />} fileName="example.pdf">
        isLoading ? <CircularProgress size={28} /> :
            <LocalPrintshopOutlinedIcon sx={{ cursor: 'pointer' }} fontSize="medium" onClick={handlePrint} />
        // </PDFDownloadLink>
    );
}

export default PdfWalletTransfer;